import { jsx as e, jsxs as I, Fragment as f } from "react/jsx-runtime";
import { useBreakpointMatch as v } from "../../../utils/use-breakpoint-match.js";
import { RocheUIAccordion as B } from "../../accordion/roche-accordion.js";
import { RocheUIAccordionAppearance as L } from "../../accordion/roche-accordion.types.js";
import { RocheUIBadge as P } from "../../badge/roche-badge.js";
import { RocheUIPipelineLaneCell as c } from "../pipeline-lane-cell/roche-pipeline-lane-cell.js";
import { RocheUIPipelineLaneRow as R } from "../pipeline-lane-row/roche-pipeline-lane-row.js";
import { PIPELINE_MOBILE_BREAKPOINT as M } from "../pipeline-lanes.js";
import m from "./roche-pipeline-group-section.module.scss.js";
const N = ({
  group: i,
  triggerLabel: d,
  lanes: n,
  itemRenderer: r,
  initiallyOpen: l = !1,
  headlineLevel: p,
  activeLaneId: h
}) => {
  const t = v(M) ? n.find((o) => o.id === h) : void 0, a = t ? i.itemsByLaneId[t.id] ?? [] : void 0, s = a ? a.length : i.items.length;
  return /* @__PURE__ */ e(
    B,
    {
      headlineLevel: p,
      sections: [
        {
          id: i.id,
          headline: d,
          badge: /* @__PURE__ */ I(f, { children: [
            /* @__PURE__ */ e("span", { className: m["pipeline-group-section__badge"], "aria-hidden": "true", children: /* @__PURE__ */ e(P, { text: s }) }),
            /* @__PURE__ */ e("span", { className: m["pipeline-group-section__visually-hidden"], children: `${s} items` })
          ] })
        }
      ],
      initiallyOpen: l ? 0 : void 0,
      appearance: L.COMPACT,
      iconVariant: "chevron",
      hasMarginTop: !1,
      hasBorderBottom: !1,
      children: [
        t ? /* @__PURE__ */ e(c, { items: a ?? [], itemRenderer: r }, i.id) : /* @__PURE__ */ e(R, { laneCount: n.length, children: n.map((o) => /* @__PURE__ */ e(
          c,
          {
            items: i.itemsByLaneId[o.id] ?? [],
            itemRenderer: r
          },
          o.id
        )) }, i.id)
      ]
    }
  );
};
export {
  N as RocheUIPipelineGroupSection
};
